import { Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { formatDateTime } from '@/shared/lib/format'
import type { ReportScopeNote } from './financeApi'

export interface ReportScopeNoteBarProps {
  note: ReportScopeNote | undefined
}

/**
 * Moliyaviy hisobotning MAJBURIY sarlavhasi — oyna, davrlar, zona va
 * «qachon hisoblangani».
 *
 * <h2>⚠️ NEGA BU MAJBURIY — QARORLAR.md §18, 3-band</h2>
 * <p>Qaror so'zma-so'z: «har moliyaviy hisobotda holat sanasi/vaqti
 * ko'rsatilsin», sababi esa: «rahbar billing panelida daromad X,
 * moliya panelida Y ko'rsa — ishonch yo'qoladi».
 *
 * <p>Bu ikki son ATAYLAB farq qiladi: `xsib-report` jonli `ledger` dan
 * o'qiydi, `xsib-finance` esa YOPILGAN davrning yig'ma provodkasidan.
 * Farqni yashirib bo'lmaydi — uni TUSHUNTIRISH kerak, va tushuntirish
 * shu qatorda.
 *
 * <h2>⚠️ OCHIQ DAVR — DASTLABKI HISOBOT</h2>
 * <p>`state = OPEN` bo'lgan davrga hali provodka yozilishi mumkin,
 * ya'ni son ertaga o'zgaradi. Yopilgan davr esa o'zgarmas
 * (`finance.period_immutable()`), ya'ni uning hisoboti takrorlanadigan.
 * Shuning uchun holat davr kodining YONIDA yoziladi.
 *
 * <p>⚠️ Komponent `shared/ui` da EMAS, `features/finance` da: u
 * `ReportScopeNote` ga bog'langan va u moliya kontrakti. Boshqa
 * modulda bunday sarlavha yo'q.
 */
export function ReportScopeNoteBar({ note }: ReportScopeNoteBarProps) {
  const { t } = useTranslation()
  if (!note) return null

  const periods =
    note.periods
      .map((p) => `${p.code} (${t(`periodState.${p.state}`, { defaultValue: p.state })})`)
      .join(', ') ||
    t('finance.reportNote.noPeriods')

  return (
    <div style={{ marginTop: 8 }}>
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        {t('finance.reportNote.window', { from: note.from, to: note.toInclusive })}
        {' · '}
        {t('finance.reportNote.periods', { periods })}
        {' · '}
        {t('finance.reportNote.timezone', { timezone: note.timezone })}
        {' · '}
        {t('finance.reportNote.generatedAt', { at: formatDateTime(note.generatedAt) })}
      </Typography.Text>
    </div>
  )
}
